<!--
 * @Author: auto-generated
 * @Date: 2024-09-16
 * @LastEditors: zry
 * @LastEditTime: 2025-09-16 13:05:22
 * @Description: 公示牌弹窗
-->
<template>
  <el-dialog
    class="o-dialog o-no-modal-bg o-dialog--sm o-dialog--md-80 o-dialog--lg-80 o-dialog--xl-80 o-dialog-h--75"
    title="消防维护保养项目公示牌"
    :visible.sync="dialogVisible"
    :show-close="false"
    :modal="false"
    :close-on-click-modal="false"
    @close="handleClose"
  >
    <div
      slot="title"
      class="dialog-header"
    >
      <span>消防维护保养项目公示牌</span>
      <div class="header-actions">
        <el-button
          icon="kestrel-icon ki-close"
          @click="handleClose"
        >
          关闭弹窗
        </el-button>
      </div>
    </div>
    <div
      v-loading="loading"
      class="gsp-content"
    >
      <div class="gsp-body">
        <div class="gsp-info-table">
          <table class="info-table">
            <tr>
              <th
                class="header-cell"
                colspan="3"
              >
                消防维护保养项目公示牌
              </th>
            </tr>
            <tr>
              <td class="label-cell">
                项目名称
              </td>
              <td class="value-cell">
                {{ gspInfo.xmmc || '-' }}
              </td>
              <td
                class="qr-cell"
                rowspan="2"
              >
                <div class="qr-code">
                  <div
                    v-if="getQrCodeUrl()"
                    class="qr-image"
                  >
                    <img
                      :src="getQrCodeUrl()"
                      alt="二维码"
                    >
                  </div>
                  <div
                    v-else
                    class="qr-placeholder"
                  >
                    <div class="qr-border">
                      <span>二维码</span>
                    </div>
                  </div>
                </div>
              </td>
            </tr>
            <tr>
              <td class="label-cell">
                单位名称
              </td>
              <td class="value-cell">
                {{ gspInfo.dwmc || '-' }}
              </td>
            </tr>
            <tr>
              <td class="label-cell">
                消防安全管理人
              </td>
              <td
                class="value-cell"
                colspan="2"
              >
                {{ gspInfo.xfaqglr || '-' }}
              </td>
            </tr>
            <tr>
              <td class="label-cell">
                项目地址
              </td>
              <td
                class="value-cell"
                colspan="2"
              >
                {{ gspInfo.xmdz || '-' }}
              </td>
            </tr>
            <tr>
              <td class="label-cell">
                维保合约期
              </td>
              <td
                class="value-cell"
                colspan="2"
              >
                {{ formatDateRange(gspInfo.wbhyqQ, gspInfo.wbhyqZ) }}
              </td>
            </tr>
            <tr>
              <td class="label-cell">
                维保内容
              </td>
              <td
                class="value-cell maintenance-content"
                colspan="2"
              >
                {{ formatWbnrList(gspInfo.wbnrJhList) }}
              </td>
            </tr>
            <tr>
              <td class="label-cell">
                技术服务机构
              </td>
              <td
                class="value-cell"
                colspan="2"
              >
                {{ gspInfo.jsfwjg || '-' }}
              </td>
            </tr>
            <tr>
              <td class="label-cell">
                项目负责人
              </td>
              <td
                class="value-cell"
                colspan="2"
              >
                {{ gspInfo.xmfzr || '-' }} （电话：{{ gspInfo.xmfzrDh || '-' }} 注册号：{{ gspInfo.xmfzrZch || '-' }}）
              </td>
            </tr>
            <tr>
              <td class="label-cell">
                维保操作员
              </td>
              <td
                class="value-cell"
                colspan="2"
              >
                {{ formatWbryList(gspInfo.wbryDmList) }}
              </td>
            </tr>
          </table>
        </div>

        <div class="gsp-notice">
          <p>温馨提示：根据《中华人民共和国应急管理部令》（第七号）第十四条：消防设施维护保养检测机构对建筑消防设施进行维护保养后。应对制作包含消防技术服务机构名称及项目负责人、维护保养日期等信息标识。在消防设施所在建筑的醒目位置上予以公示。</p>
        </div>
      </div>
    </div>

    <div
      slot="footer"
      class="dialog-footer"
    >
      <k-button
        btn-text="打印"
        type="primary"
        icon="kestrel-icon ki-print"
        @click="handlePrint"
      />
      <k-button
        btn-text="导出Word"
        type="success"
        icon="kestrel-icon ki-export"
        @click="handleExportWord"
      />
    </div>
  </el-dialog>
</template>

<script>
import { bgglService } from './bggl.service.js';

export default {
  name: 'GspDialog',
  props: {
    dlParams: {
      type: Object,
      default: () => ({})
    }
  },
  data () {
    return {
      loading: false,
      dialogVisible: true,
      gspInfo: {} // 公示牌信息，从后端获取
    };
  },
  methods: {
    /**
     * @description: 获取公示牌信息
     */
    getGspInfo () {
      if (!this.dlParams.id) {
        this.$message.error('缺少必要的参数');
        return;
      }

      this.loading = true;
      bgglService.getGspInfo(this.dlParams.id)
        .then(rsp => {
          this.gspInfo = rsp.data || {};
          console.log('获取公示牌信息', this.gspInfo);

          // 显示预期的二维码URL（用于验证）
          if (this.gspInfo.xmId) {
            const expectedQrUrl = `${window.location.origin}/public/wbbg?xmId=${this.gspInfo.xmId}`;
            console.log('预期的二维码URL:', expectedQrUrl);
          }
        })
        .catch(err => {
          console.error('获取公示牌信息失败！', err);
          this.$message.error('获取公示牌信息失败！');
        })
        .finally(() => {
          this.loading = false;
        });
    },

    /**
     * @description: 关闭弹窗
     */
    handleClose () {
      this.dialogVisible = false;
      this.$emit('closeDialog', '');
    },

    /**
     * @description: 格式化日期范围
     * @param {string} startDate 开始日期
     * @param {string} endDate 结束日期
     * @return {string} 格式化后的日期范围
     */
    formatDateRange (startDate, endDate) {
      if (!startDate || !endDate) {
        return '-';
      }
      return `${startDate} 至 ${endDate}`;
    },

    /**
     * @description: 格式化维保内容列表
     * @param {Array} wbnrList 维保内容列表
     * @return {string} 格式化后的维保内容
     */
    formatWbnrList (wbnrList) {
      if (!wbnrList || !Array.isArray(wbnrList) || wbnrList.length === 0) {
        return '-';
      }
      return wbnrList.map(item => item.wbnrMc).join('，');
    },

    /**
     * @description: 格式化维保人员列表
     * @param {Array} wbryList 维保人员列表
     * @return {string} 格式化后的维保人员信息
     */
    formatWbryList (wbryList) {
      if (!wbryList || !Array.isArray(wbryList) || wbryList.length === 0) {
        return '-';
      }
      return wbryList.map(item => {
        const name = item.userName || '-';
        const zsbh = item.userZsbh || '-';
        return `${name} （证书号：${zsbh}）`;
      }).join('、');
    },

    /**
     * @description: 获取二维码图片URL
     * @return {string} 二维码图片的Data URL
     */
    getQrCodeUrl () {
      if (!this.gspInfo.qrCode) {
        return null;
      }

      // 处理不同格式的二维码数据
      const qrCode = this.gspInfo.qrCode;

      // 如果是字符串格式（直接的data URL）
      if (typeof qrCode === 'string') {
        return qrCode;
      }

      // 如果是对象格式（包含data字段）
      if (typeof qrCode === 'object' && qrCode.data) {
        // 根据path判断图片格式
        const format = qrCode.path ? qrCode.path.replace('.', '') : 'png';
        return `data:image/${format};base64,${qrCode.data}`;
      }

      return null;
    },

    /**
     * @description: 验证二维码内容（开发调试用）
     * @return {string} 二维码应该包含的URL
     */
    getExpectedQrUrl () {
      if (!this.gspInfo.xmId) {
        return null;
      }
      return `${window.location.origin}/#/public/wbbg?xmId=${this.gspInfo.xmId}`;
    },

    /**
     * @description: 测试二维码功能
     */
    testQrCode () {
      const qrUrl = this.getExpectedQrUrl();
      if (qrUrl) {
        // 在新标签页打开二维码URL进行测试
        window.open(qrUrl, '_blank');
        this.$message.success(`已打开测试页面: ${qrUrl}`);
      } else {
        this.$message.warning('无法获取二维码URL');
      }
    },

    /**
     * @description: 打印功能
     */
    handlePrint () {
      // 创建打印样式
      const printStyles = `
        <style>
          @page {
            size: A4 portrait;
            margin: 15mm;
          }
          @media print {
            body * { visibility: hidden; }
            .gsp-content, .gsp-content * { visibility: visible; }
            .gsp-content {
              position: absolute;
              left: 0;
              top: 0;
              width: 100%;
              padding: 0;
              font-family: '微软雅黑', sans-serif;
            }
            .header-cell {
              background-color: #fff;
              font-size: 18px;
              font-weight: bold;
              text-align: center;
              padding: 15px 8px;
            }
            .info-table {
              width: 100%;
              border-collapse: collapse;
              margin-bottom: 20px;
              border: 2px solid #333;
            }
            .info-table th, .info-table td {
              border: 1px solid #333;
              padding: 8px;
              font-size: 14px;
            }
            .label-cell {
              background-color: #f5f5f5;
              font-weight: bold;
              width: 120px;
            }
            .value-cell {
              min-width: 300px;
            }
            .qr-cell {
              width: 120px;
              text-align: center;
              vertical-align: middle;
            }
            .qr-code {
              width: 100px;
              height: 100px;
              border: 1px solid #ddd;
              display: flex;
              align-items: center;
              justify-content: center;
              margin: 0 auto;
            }
            .qr-image img {
              width: 90px;
              height: 90px;
            }
            .gsp-notice {
              border-top: 1px solid #ddd;
              padding-top: 15px;
              font-size: 12px;
              color: #666;
            }
          }
        </style>
      `;

      // 获取要打印的内容
      const printContent = document.querySelector('.gsp-content').innerHTML;

      // 创建新窗口进行打印
      const printWindow = window.open('', '_blank');
      printWindow.document.write(`
        <!DOCTYPE html>
        <html>
          <head>
            <title>消防维护保养项目公示牌</title>
            ${printStyles}
          </head>
          <body>
            <div class="gsp-content">
              ${printContent}
            </div>
          </body>
        </html>
      `);

      printWindow.document.close();

      // 等待内容加载完成后打印
      setTimeout(() => {
        printWindow.print();
        printWindow.close();
      }, 500);
    },

    /**
     * @description: 导出Word功能
     */
    handleExportWord () {
      if (!this.dlParams.id) {
        this.$message.error('缺少必要的参数');
        return;
      }

      this.loading = true;
      bgglService.exportGspWord(this.dlParams.id)
        .then(rsp => {
          const fileStream = rsp.data;
          // 后端固定返回文件名为 "消防维护保养项目公示牌.docx"
          const fileName = decodeURIComponent(escape(rsp.headers['content-disposition']?.split('=')[1])) ||
                          '消防维护保养项目公示牌.docx';
          this.$HMUtil.downloadStreamFile(fileStream, fileName);
          this.$message.success('Word文档导出成功！');
        })
        .catch(err => {
          console.error('导出Word失败：', err);
          this.$message.error('导出Word失败，请重试！');
        })
        .finally(() => {
          this.loading = false;
        });
    }
  },
  created () {
    this.getGspInfo();
  }
};
</script>

<style lang="scss" scoped>
.gsp-content {
  padding: 20px;
  font-family: '微软雅黑', sans-serif;
  line-height: 1.6;
}

.gsp-info-table {
  margin-bottom: 20px;
}

.info-table {
  width: 100%;
  border-collapse: collapse;
  border: 2px solid #333;

  th, td {
    border: 1px solid #333;
    padding: 12px 8px;
    font-size: 14px;
    vertical-align: top;
  }

  .header-cell {
    background-color: #fff;
    font-size: 18px;
    font-weight: bold;
    text-align: center;
    padding: 15px 8px;
  }

  .label-cell {
    background-color: #f8f9fa;
    font-weight: bold;
    width: 120px;
    text-align: center;
  }

  .value-cell {
    min-width: 300px;
    padding-left: 15px;

    &.maintenance-content {
      max-width: 300px;
      word-wrap: break-word;
      white-space: normal;
    }
  }

  .qr-cell {
    width: 120px;
    text-align: center;
    vertical-align: middle;
    padding: 10px;
  }
}

.qr-code {
  width: 100px;
  height: 100px;
  border: 1px solid #ddd;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 auto;
  background-color: #f9f9f9;

  .qr-image img {
    width: 90px;
    height: 90px;
    object-fit: contain;
  }

  .qr-placeholder {
    color: #999;
    font-size: 12px;
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .qr-border {
    border: 1px solid #ddd;
    width: 90px;
    height: 90px;
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: #f9f9f9;
    border-radius: 4px;
  }
}

.gsp-notice {
  border-top: 1px solid #ddd;
  padding-top: 15px;

  p {
    margin: 0;
    font-size: 12px;
    color: #666;
    line-height: 1.8;
    text-indent: 2em;
  }
}

.dialog-header {
  display: flex;
  width: 100%;
  font-size: 18px;
  align-items: center;
  justify-content: space-between;
}

.header-actions {
  margin-left: auto;
}

.dialog-footer {
  text-align: right;

  .k-button + .k-button {
    margin-left: 10px;
  }
}
</style>
